<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalInvoiceVisible" :vm-is-valid="!$v.invoice.$invalid" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("invoices.folio_placeholder")' :danger="$v.invoice.folio.$invalid && $v.invoice.folio.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.folio') })" v-model="invoice.folio" :label='$t("invoices.folio")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("invoices.invoice_date")' :danger="$v.invoice.invoice_date.$invalid && $v.invoice.invoice_date.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.invoice_date') })" v-model="invoice.invoice_date")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-currency(:placeholder='$t("invoices.amount_placeholder")' :danger="$v.invoice.amount.$invalid && $v.invoice.amount.$model" v-model="invoice.amount" :label='$t("invoices.amount")+" ("+$t("invoices.available_amount")+": $"+amountDueFormatted+")"' :danger-text='$t("invoices.exceeded_amount")+amountDueFormatted')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:label='$t("invoices.type")', v-model='invoice.type' :danger="$v.invoice.type.$invalid && $v.invoice.type.$model" :placeholder='$t("invoices.type_placeholder")')
            vm-select-item(:value='1', text='Cano Steel to Client')
            vm-select-item(:value='2', text='Suppliers to CanoSteel')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          input(type="file" ref="file" accept="image/jpg, image/jpeg, image/png, application/pdf" @change="handleFileUpload()")
</template>
<script>
import moment from 'moment'
import { required, requiredIf, maxValue } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalInvoice',
  props: {
    invoice: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    file: ''
  }),
  validations () {
    return {
      invoice: {
        invoice_date: {
          required
        },
        folio: {
          required
        },
        amount: {
          required,
          maxValue: maxValue(this.amountDue)
        },
        type: {
          required
        },
        file: {
          required: requiredIf(function () { return this.fileValidate })
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalInvoiceVisible',
      'inOrder'
    ]),
    amountDueFormatted () {
      const amount = this.amountDue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return amount
    },
    getTitle () {
      return this.isAdd ? this.$t('invoices.add') : this.$t('invoices.edit')
    },
    amountDue () {
      return this.inOrder.amount_due_invoice ? this.inOrder.amount_due_invoice : 0
    },
    fileValidate () {
      return this.file.length < 1 && this.isAdd
    }
  },
  methods: {
    ...mapActions([
      'setModalInvoiceVisible',
      'addInvoice',
      'editInvoice'
    ]),
    async handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      this.invoice.invoice_date = moment(this.invoice.invoice_date).format('YYYY-MM-DD')
      this.isAdd ? await this.addInvoice({ invoice: this.invoice, project: this.inOrder, file: this.file }) : await this.editInvoice({ invoice: this.invoice })
      this.file = ''
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalInvoiceVisible(false)
    }
  }
}
</script>
